import { NgModule } from '@angular/core';
import { InumberDirective } from './inumber.directive';
import { InumberVnDirective } from './inumbervn.directive';

@NgModule({
    declarations: [InumberDirective, InumberVnDirective],
    imports: [],
    exports: [InumberDirective, InumberVnDirective],
})
export class SharedDirectiveModule { }
